export const ALLOWED_JOIN_MEMBERSHIP_PARAMS = new Set([
  'step',
  'callbackUrl',
  'errorCode',
  'emailExists',
  'tierType',
  'campaign',
  'svn',
  'eventLabel',
  'provider',
  'referral',
  'type',
  'app',
]);

const constants = {
  HTTP_STATUS: {
    UNPROCESSABLE_ENTITY: 422,
  },
};

export default constants;
